import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataBusService {
  constructor() {}

  /* Timers in milliseconds*/
  public timers = {
    hardToken: 2 * 60 * 1000,
    sessionDisplayTimer: 2 * 60 * 1000, // Timer to display over the session overlay.
    sessionInterval: 1 * 60 * 1000, // Interval time to display the session overlay.
  };

  public tmpRenewTimer: any;
  public sessionTimeoutContents: any;
}
